import { render } from "./a-pager.vue?vue&type=template&id=b5d17912&scoped=true"
import script from "./a-pager.vue?vue&type=script&lang=js"
export * from "./a-pager.vue?vue&type=script&lang=js"

import "./a-pager.vue?vue&type=style&index=0&id=b5d17912&lang=scss&scoped=true"

import exportComponent from "/www/publicHouse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5d17912"]])

export default __exports__